import React from 'react'
import { Badge, Container, ListGroup } from 'react-bootstrap'


function Projects() {
    return (
        <div style={{backgroundColor:'#BC3C71',
        paddingTop:'10px'
        }}>
           
           <Container>
           <h1>My projects</h1>

<ListGroup as="ol" numbered>
<ListGroup.Item
as="li"
className="d-flex justify-content-between align-items-start"
>
<div className="ms-2 me-auto">
<div className="fw-bold">Doctor plus</div>
<a href="https://doctors-care-21f96.web.app/">Website</a> <span/> 
<a href="https://github.com/Dipctg/healthcare-related-website">Github</a>
</div>
<Badge variant="primary" pill>
Running project
</Badge>
</ListGroup.Item>
<ListGroup.Item
as="li"
className="d-flex justify-content-between align-items-start"
>
<div className="ms-2 me-auto">
<div className="fw-bold">Sunglass Portal</div>
<a href="https://sunglass-portal.firebaseapp.com/">Website</a> <span/> 
<a href="https://github.com/Dipctg/sunglass-portal-client-side">Github</a>
</div>
<Badge variant="primary" pill>
Running project
</Badge>
</ListGroup.Item>

</ListGroup>
           </Container>
           <br/>
        </div>
    )
}

export default Projects

